export default class File
{
    /**
     * @param text
     * @returns {*}
     */
    static removeExtension(text) {
        return text.split('.')[0];
    }
}
